import React from 'react';
import { AccessibilityProvider } from '../contexts/AccessibilityContext';
import SkipNavigation from './SkipNavigation';
import AccessibilityToolbar from './AccessibilityToolbar';

const AccessibilityWrapper = ({ children }) => {
  return (
    <AccessibilityProvider>
      <SkipNavigation />
      {children}
      <AccessibilityToolbar />
    </AccessibilityProvider>
  );
};

export default AccessibilityWrapper;